import { Link } from 'react-router-dom';
import { useWorkspaceObjectives } from '@/lib/workspace-objectives';
import { useObjectiveProgress } from '@/lib/objective-progress';
import { ObjectiveProgressLine } from './ObjectiveProgressLine';

const OBJECTIVES_HREF = '/profil?tab=objectives';

/**
 * Small dashboard of Aujourd'hui (J3, 15/10): only the objectives followed by a
 * number (a measure on an app list), each with its exact count and weekly pace.
 * An objective without measure has nothing to follow each day: it lives in
 * Profil › Objectifs, and the band takes no place.
 */
export const TodayObjectives = () => {
  const { objectives, measures, userId, loading, error } = useWorkspaceObjectives();
  const measured = objectives.filter((goal) =>
    goal.status === 'active' && (goal.scope === 'company' || goal.owner_user_id === userId) && measures[goal.id]
  );
  const measuredIds = measured.map((goal) => goal.id);
  const { progress } = useObjectiveProgress(
    measuredIds,
    measuredIds.map((id) => measures[id]?.updated_at ?? '').join('|'),
    measuredIds.filter((id) => measures[id]?.source !== 'app_status'),
  );

  if (loading || error || measured.length === 0) return null;
  return (
    <section aria-label='Objectifs en cours' className='grid gap-2 sm:grid-cols-2 lg:grid-cols-4'>
      {measured.map((goal) => {
        const measure = measures[goal.id];
        return measure ? (
          <article key={goal.id} className='min-w-0 rounded-lg border border-domino-cardBorder bg-domino-white px-3 py-2'>
            <ObjectiveProgressLine
              objective={goal}
              measure={measure}
              progress={progress[goal.id]}
              heading={
                <Link to={OBJECTIVES_HREF} title={goal.title} className='min-w-0 truncate text-xs font-medium text-domino-ink hover:text-domino-aubergine'>
                  {goal.title}
                </Link>
              }
            />
          </article>
        ) : null;
      })}
    </section>
  );
};
